import Layout from "../../components/mainPage/Layout";
import SwitchingBlanck from "../../images/systemComponents/SwitchingBlanck.png";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    Автоматическое формирование бланков переключений
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Данные текущих измерений, поступающие в SCADA NPT Expert и результаты работы расчетных функций, основанные на стандарте CIM (Common Information Model), позволяют <b>автоматически сформировать бланки переключений</b>, исходя из текущего режима и схемы сети. Такой бланк называется <b>Динамическим бланком переключений</b>. 
                    </p>
                    <p >
                        Динамический бланк переключений позволяет автоматически сформировать перечень операций для выполнения типовых сценариев переключений (например, отключение линии электропередач) с контролем каждого шага по текущим измеряемым сигналам и по данным расчета режима. Например, для вывода одной из двух питающих линии динамический бланк при формировании операций выполнит проверку перераспределения мощности, чтобы не допустить перегрузки оборудования при новой схеме сети. 
                    </p>
                    <p >
                        Динамический бланк переключений является продвинутым инструментом для безопасного выполнения операций по переключениям в энергосистеме. Он позволяет автоматизировать процессы, связанные с изменениями конфигурации сети, что повышает безопасность, надежность и эффективность работы энергосистемы.
                    </p>                    
                    <img
                        src={SwitchingBlanck}
                        className="mb-4  w-100"
                        alt="Бланк переключений"
                    />
                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Планирование переключений</b>
                            <ul>
                                <li>Разработка последовательности операций для безопасного выполнения переключений. </li>
                                <li>Проверка корректности предлагаемых переключений с учетом текущего состояния сети (на основе данных SCADA NPT Expert).</li>
                                <li>Минимизация рисков возникновения аварийных ситуаций при выполнении переключений.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Автоматизация создания бланков переключений</b>
                            <ul>
                                <li>Генерация бланков переключений на основе данных CIM и текущего состояния сети.</li>
                                <li>Уменьшение ручного труда и снижение вероятности ошибок при составлении бланков.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Контроль выполнения переключений</b>
                            <ul>
                                <li>Обеспечение пошагового выполнения операций в соответствии с утвержденным бланком.
                                </li>
                                <li>Контроль состояния оборудования в реальном времени через SCADA NPT Expert.</li>
                                <li>Проверка корректности переключений с учетом требований безопасности</li>
                                <li>Предупреждение диспетчера о возможных ошибках или отклонениях от плана.</li>
                                <li>Предупреждение о потенциально опасных операциях (например, отключение нагрузки без резервирования).</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Документирование и отчетность</b>
                            <ul>
                                <li>Автоматическое создание отчетов о выполненных переключениях.
                                </li>
                                <li>Хранение истории всех операций для последующего анализа и аудита.</li>
                                <li>Обеспечение прозрачности и подотчетности при выполнении переключений.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Поддержка различных режимов работы</b>
                            <ul>
                                <li> Планирование переключений в нормальных режимах работы сети.
                                </li>
                                <li>Выполнение переключений в аварийных ситуациях для восстановления энергоснабжения.</li>
                                <li>Поддержка режимов планового ремонта и технического обслуживания.</li>
                            </ul>
                        </li>


                    </ul>

                </div>

            </div>
        </div>
    </Layout>
}